<template>
    <transition name="fade">
        <div class="city_box" v-if="visible">
            <div class="mask" v-if="!useNewestStyle">
                <div class="search_box1 re" v-if="needShowSearch">
                    <input type="text" class="search_input" placeholder="北京/beijing" v-model="cityName" @input="searchCity">
                    <img class="search_icon ab" src="//file.40017.cn/img140017cnproduct/cn/c/topic/newguest/search1.png" alt="">
                </div>
                <div class="scrollable">
                    <div class="default_box" v-if="!showResult">
                        <div class="locate_box re" v-if="needLocateFlag&&locateType===1">
                            <p class="locate_p" v-if="locateObj" @click="choose(locateObj)"><span>{{locateObj.cityName}}</span><span class="locate_sp" v-if="locateObj.isSuccess">{{ GPSLabel }}</span><span class="locate_sp" v-if="!locateObj.isSuccess">{{ localeFailLabel }}</span></p>
                            <img class="locate_icon ab" src="//file.40017.cn/img140017cnproduct/cn/c/topic/newguest/locate_icon.png" alt="">
                        </div>
                        <div class="history-box hot_box" v-if="historyCityList.length>0">
                            <p class="hot_box_p">{{ historyLabel }}</p>
                            <div class="hot_city">
                                <p class="hote_city_p" v-for="(item, index) in historyCityList" :key="index">
                                    <span class="h_c_sp1" @click="choose(item)">{{item.cityName}}</span>
                                </p>
                            </div>
                        </div>
                        <div class="hot_box" v-if="!hideHotCity">
                            <p class="hot_box_p">{{ hotCityLabel }}</p>
                            <div class="hot_city" v-if="hotCityList.length>0">
                                <p class="hote_city_p" v-for="(item, index) in hotCityList" :key="index">
                                    <span class="h_c_sp1" v-if="item[0]" @click="choose(item[0])">{{item[0].cityName}}</span>
                                    <span class="h_c_sp2" v-if="item[1]" @click="choose(item[1])">{{item[1].cityName}}</span>
                                    <span class="h_c_sp3" v-if="item[2]" @click="choose(item[2])">{{item[2].cityName}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="result_box" v-if="showResult && !showLoading">
                        <div class="hot_city" v-if="searchCityList.length>0">
                            <p class="hote_city_p" v-for="(item, index) in searchCityList" :key="index">
                                <span class="h_c_sp1" v-if="item[0]" @click="choose(item[0])">{{item[0].cityName}}</span>
                                <span class="h_c_sp2" v-if="item[1]" @click="choose(item[1])">{{item[1].cityName}}</span>
                                <span class="h_c_sp3" v-if="item[2]" @click="choose(item[2])">{{item[2].cityName}}</span>
                            </p>
                        </div>
                        <p class="hote_city_p" v-if="searchCityList.length <= 0"><span class="h_c_sp1">{{ noResultLabel }}</span></p>
                    </div>
                    <div class="loading_box" v-if="showResult && showLoading">
                        <img class="load_img" src="//file.40017.cn/img140017cnproduct/cn/c/topic/loading1.gif" alt="">
                    </div>
                </div>
                <div class="city_close" @click="hideCity()">
                    <img src="//file.40017.cn/img140017cnproduct/cn/c/topic/newguest/close_city.png" alt="">
                </div>
            </div>
            <!-- 新版城市选择 -->
            <div class="city-pop" v-if="useNewestStyle">
                <div class="header-title">
                    <svg @click="hideCity()" t="1648525256587" class="back icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2546" width="200" height="200">
                        <path d="M639.3 151.4L314 476.6c-19.5 19.5-19.5 51.2 0 70.7l325.3 325.3c19.5 19.5 51.2 19.5 70.7 0s19.5-51.2 0-70.7L420.1 512 710 222.1c19.5-19.5 19.5-51.2 0-70.7-19.5-19.6-51.2-19.6-70.7 0z" p-id="2547" fill="#000000"></path>
                    </svg>
                    {{ regionLabel }}
                </div>
                <div class="city_box_content">
                    <div class="fast-op-box">
                        <div v-if="!!isInternCity" class="city_type_tab">
                            <div :class="['tab-item', { active: currentCityType === item.id }]" v-for="item in cityTypeTab" :key="item.id" @click="onChooseCityType(item)">
                                 {{cityTypeLabel(item)}} <!-- <img v-if="item.id === 2" src="https://pic5.40017.cn/i/ori/1DIqjhz6STS.png" alt="" width="14px" height="14px" /> -->
                            </div>
                        </div>
                        <div v-if="currentCityType == 1">
                            <p class="now-tip title">{{ currentLocationLabel }}</p>
                            <div class="locate" @click="choose(locateObj)">
                                <img src="https://file.40017.cn/img140017cnproduct/cn/c/marketactivityconfig/components/project-department-tab/locate.png" />
                                <span>{{ getCityName(locateObj) }}</span>
                                <span class="locate_sp" @click.stop="reLocate()" v-if="!locateObj.isSuccess">{{ localeFailLabel }}</span>
                            </div>
                            <template v-if="!hideHotCity">
                                <p class="hot-title title">{{ hotCityLabel }}</p>
                                <div class="city-item" @click="choose(item)" v-for="item in newStyleHotCityList" :key="item.tcCityId">
                                    {{ getCityName(item)}}
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="letter-box">
                        <div class="letter-item" v-for="(item,index) in allAreaList" :key="item.py">
                            <p class="letter-title" :class="'letter-title'+item.py" @click="setActiveLetter(item.py,index)">{{item.py}}</p>
                            <template v-if="activeLetter ===item.py">
                                <div class="letter-city" @click="choose(city)" v-for="(city, idx) in item.list" :key="city.tcCityId + '_' + idx">
                                    {{getCityName(city)}}<span v-if="currentCityType == 2 && city.countryName">({{city.countryName}})</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="right-item" @click="setActiveLetter(item.py,index)" v-for="item,index in allAreaList" :key="item.py">
                        {{item.py}}
                    </div>
                </div>
            </div>
        </div>
    </transition>

</template>
<script>
export default {
    data() {
        return {
            visible: false,
            locateObj: '',
            hotCity: '',
            selectCityObj: {},
            isGetResource: '',
            cityType: '',
            cityName: '',
            searchCityList: [],
            historyCityList: [],
            showResult: false,
            showLoading: false,
            type: null,
            hotCityList: [],
            newStyleHotCityList: [],
            hotCity: [
                {
                    tcCityId: 53,
                    cityName: '北京',
                    countryName: '中国',
                    elCityId: '0101',
                    threeCode: 'BJS',
                    chineseNamePY: 'beijing'
                },
                {
                    tcCityId: 321,
                    cityName: '上海',
                    countryName: '中国',
                    elCityId: '0201',
                    threeCode: 'SHA',
                    chineseNamePY: 'shanghai'
                },
                {
                    tcCityId: 80,
                    cityName: '广州',
                    countryName: '中国',
                    elCityId: '2001',
                    threeCode: 'CAN',
                    chineseNamePY: 'guangzhou'
                },
                {
                    tcCityId: 91,
                    cityName: '深圳',
                    countryName: '中国',
                    elCityId: '2003',
                    threeCode: 'SZX',
                    chineseNamePY: 'shenzhen'
                },
                {
                    tcCityId: 324,
                    cityName: '成都',
                    countryName: '中国',
                    elCityId: '2301',
                    threeCode: 'CTU',
                    chineseNamePY: 'chengdu'
                },
                {
                    tcCityId: 383,
                    cityName: '杭州',
                    countryName: '中国',
                    elCityId: '1201',
                    threeCode: 'HGH',
                    chineseNamePY: 'hangzhou'
                },
                {
                    tcCityId: 317,
                    cityName: '西安',
                    countryName: '中国',
                    elCityId: '2701',
                    threeCode: 'SIA',
                    chineseNamePY: 'xian'
                },
                {
                    tcCityId: 394,
                    cityName: '重庆',
                    countryName: '中国',
                    elCityId: '0401',
                    threeCode: 'CKG',
                    chineseNamePY: 'chongqing'
                },
                {
                    tcCityId: 192,
                    cityName: '武汉',
                    countryName: '中国',
                    elCityId: '1801',
                    threeCode: 'WUH',
                    chineseNamePY: 'wuhan'
                },
                {
                    tcCityId: 199,
                    cityName: '长沙',
                    countryName: '中国',
                    elCityId: '1901',
                    threeCode: 'CSX',
                    chineseNamePY: 'changsha'
                },
                {
                    tcCityId: 224,
                    cityName: '南京',
                    countryName: '中国',
                    elCityId: '1101',
                    threeCode: 'NKG',
                    chineseNamePY: 'nanjing'
                },
                {
                    tcCityId: 61,
                    cityName: '厦门',
                    countryName: '中国',
                    elCityId: '1401',
                    threeCode: 'XMN',
                    chineseNamePY: 'xiamen'
                },
                {
                    tcCityId: 108,
                    cityName: '南宁',
                    countryName: '中国',
                    elCityId: '2102',
                    threeCode: 'NNG',
                    chineseNamePY: 'nanning'
                },
                {
                    tcCityId: 256,
                    cityName: '沈阳',
                    countryName: '中国',
                    elCityId: '0802',
                    threeCode: 'SHE',
                    chineseNamePY: 'shenyang'
                },
                {
                    tcCityId: 292,
                    cityName: '青岛',
                    countryName: '中国',
                    elCityId: '1601',
                    threeCode: 'TAO',
                    chineseNamePY: 'qingdao'
                },
                {
                    tcCityId: 343,
                    cityName: '天津',
                    countryName: '中国',
                    elCityId: '0301',
                    threeCode: 'TSN',
                    chineseNamePY: 'tianjin'
                },
                {
                    tcCityId: 373,
                    cityName: '昆明',
                    countryName: '中国',
                    elCityId: '2501',
                    threeCode: 'KMG',
                    chineseNamePY: 'kunming'
                },
                {
                    tcCityId: 226,
                    cityName: '苏州',
                    countryName: '中国',
                    elCityId: '1102',
                    threeCode: 'SZV',
                    chineseNamePY: 'suzhuo'
                },
                {
                    tcCityId: 364,
                    cityName: '乌鲁木齐',
                    countryName: '中国',
                    elCityId: '3101',
                    threeCode: 'URC',
                    chineseNamePY: 'wulumuqi'
                },
                {
                    tcCityId: 239,
                    cityName: '南昌',
                    countryName: '中国',
                    elCityId: '1501',
                    threeCode: 'KHN',
                    chineseNamePY: 'nanchang'
                },
            ],
            allAreaList: [],
            activeLetter: 'A',
            cityTypeTab: [
                {
                    name: '国内•港澳台',
                    id: 1,
                },
                {
                    name: '国际城市',
                    id: 2
                },
            ],
            currentCityType: 1, // 当前城市类型 1: 国内•港澳台 2: 国际城市
            cityLevel: '3,4', // 城市级别，默认3,4（市和区县），可通过外部传入level参数修改
        }
    },
    computed:{
        cityTypeLabel() {
            return function(params) {
                if (params.id === 1) {
                    return {
                        'zh-CN': '国内•港澳台',
                        'zh-HK': '國內•港澳台',
                        'en': 'Domestic',
                    }[this.language] || '国内•港澳台';
                } else if (params.id === 2) {
                    return {
                        'zh-CN': '国际城市',
                        'zh-HK': '國際城市',
                        'en': 'International',
                    }[this.language] || '国际城市';
                }
            }
        },
        regionLabel() {
            return {
                'zh-CN': '选择地区',
                'zh-HK': '選擇地區',
                'en': 'Select Region',
            }[this.language] || '选择地区';
        },
        historyLabel() {
            return {
                'zh-CN': '历史选择',
                'zh-HK': '歷史選擇',
                'en': 'History Selection',
            }[this.language] || '历史选择';
        },
        hotCityLabel() {
            return {
                'zh-CN': '热门城市',
                'zh-HK': '熱門城市',
                'en': 'Popular Cities',
            }[this.language] || '热门城市';
        },
        localeFailLabel() {
            return {
                'zh-CN': '定位失败，点击重试',
                'zh-HK': '定位失敗，點擊重試',
                'en': 'Location failed, click to retry',
            }[this.language] || '定位失败，点击重试';
        },
        currentLocationLabel() {
            return {
                'zh-CN': '当前位置',
                'zh-HK': '當前位置',
                'en': 'Current Location',
            }[this.language] || '当前位置';
        },
        noResultLabel() {
            return {
                'zh-CN': '查无结果',
                'zh-HK': '查無結果',
                'en': 'No results found',
            }[this.language] || '查无结果';
        },
        GPSLabel() {
            return {
                'zh-CN': 'GPS定位',
                'zh-HK': 'GPS定位',
                'en': 'GPS Location',
            }[this.language] || 'GPS定位';
        },
        getCityName() {
            return function(item) {
                if (this.language === 'zh-CN') {
                    return item.cityName;
                } else if (this.language === 'zh-HK') {
                    if (this.languageConvert) {
                        return this.languageConvert(item.cityName)
                    }
                    return item.cityName;
                } else if (this.language === 'en') {
                    return item.englishName || item.chineseNamePY || item.cityName;
                }
                return item.cityName;
            }
        },
    },
    mounted() {
        if (this.needLocateFlag) {
            this.initLocate()
        }
        this.showCity()
        this.initAreaList()
        this.getAllCity('A', 0)
    },
    watch: {
        // 切换城市类型
        currentCityType(newVal) {
            this.activeLetter = 'A'
            this.allAreaList[0].list = []
            if (newVal === 1) {
               this.getAllCity('A', 0)
            } else {
                this.getAllInterCity('A', 0)
            }
        },
    },
    methods: {
        onChooseCityType(item){
            if(item.id === this.currentCityType) return
            this.currentCityType = item.id
        },
        initLocate() {
            const defaultCity = {
                isSuccess: false, //res.latitude&&res.longitude,
                latitude: '31.236301', //	纬度	Number	-	-
                longitude: '121.480236', //	经度	Number	-	-
                speed: '', //	速度	Number	-	只有微信H5/微信小程序/外部H5
                accuracy: '', //	位置的精确度	Number	-	只有微信H5/微信小程序/外部H5
                altitude: '', //	高度	Number	-	只有百度小程序支持/外部H5
                provName: '上海', //	省份名称	String	-	-
                cityName: '上海', //	城市名称	String	-	-
                englishName: 'Shanghai', //	英文名称	String
                tcProvId: '25', //	同程省份Id	Number	-	-
                tcCityId: '321', //	同程城市Id	Number	-	-
                elCityId: '0201', //	艺龙城市Id	String	-	不支持同程APP
                threeCode: 'SHA',
            }
            try {
                if (this.popType) {
                    // console.log('新缓存')
                    this.locateObj = JSON.parse(localStorage.locateNewObj)
                } else {
                    //  console.log('老缓存')
                    this.locateObj = JSON.parse(localStorage.locateObj)
                }
                if (!this.locateObj.cityName) {
                    this.locateObj = defaultCity
                }
            } catch (e) {
                this.locateObj = defaultCity
            }
        },
        reLocate() {
            this.$UI.location({
                data: {
                    retry: true,
                    background: true,
                },
                callback: (res) => {
                    if (
                        (res.currentLocation &&
                            res.currentLocation.isSuccess) ||
                        (res.historyLocation && res.historyLocation.isSuccess)
                    ) {
                        this.initLocate()
                    }
                },
            })
        },
        // 显示城市列表
        showCity() {
            if (
                this.needCustomizeData &&
                this.customizeHotCity &&
                this.customizeHotCity.length
            ) {
                this.initHotCity(this.customizeHotCity)
            } else if (this.hotCity && this.hotCity.length) {
                this.initHotCity(this.hotCity)
            }
            this.cityName = ''
            this.showResult = false
            this.visible = true
            this.afterOpen('modal-open')
        },
        // 隐藏城市列表
        hideCity() {
            this.visible = false
            this.cityName = ''
            this.showResult = false
            this.searchCityList = []
            this.beforeClose('modal-open')
        },
        // 搜索城市列表
        searchCity() {
            this.getCity()
        },
        getCity() {
            this.showLoading = true
            if (this.cityName !== '') {
                this.showResult = true
                this.$http({
                    url: '/actgateway/marketcenter.java.activity.resource.service/v2/city/getCityInfoFromSearch',
                    method: 'get',
                    data: {
                        cityName: this.cityName,
                        tcCityId: '',
                        lon: '',
                        lat: '',
                        refreshCache: '',
                        likeSearch: true,
                    },
                })
                    .then(({ data }) => {
                        this.showLoading = false
                        if (data.code === '0000') {
                            data.result = data.result.map((item) => {
                                switch (item.nameShort) {
                                    case '香港':
                                        item.nameShort = '中国香港'
                                        break
                                    case '澳门':
                                        item.nameShort = '中国澳门'
                                        break
                                    case '台湾':
                                        item.nameShort = '中国台湾'
                                        break
                                }
                                return {
                                    latitude: item.latbd, //纬度	Number	-
                                    longitude: item.lonbd, //经度	Number	-
                                    provName: item.provName, //省份名称	String	-
                                    cityName: item.nameShort, //城市名称	String	-
                                    tcProvId: item.provId, //同程省份Id	Number	-
                                    tcCityId: item.id, //同程城市Id	Number	-
                                    threeCode: item.threeCode,
                                    elCityId:
                                        (item.eRegion && (item.eRegion.euId || item.eRegion.eid)) ||
                                        '', //艺龙城市Id	String
                                }
                            })
                            if (data.result && data.result.length > 0) {
                                this.handle(data.result)
                            } else {
                                this.searchCityList = []
                            }
                        } else {
                            this.searchCityList = []
                        }
                    })
                    .catch((err) => {
                        this.showLoading = false
                        this.searchCityList = []
                    })
            } else {
                this.showResult = false
            }
        },
        handle(data) {
            this.searchCityList = []
            for (var i = 0, len = data.length; i < len; i += 3) {
                this.searchCityList.push(data.slice(i, i + 3))
            }
        },
        // 初始化热门城市
        initHotCity(data) {
            this.hotCityList = []
            this.newStyleHotCityList = []
            this.newStyleHotCityList = data
            for (var i = 0, len = data.length; i < len; i += 3) {
                this.hotCityList.push(data.slice(i, i + 3))
            }
        },
        async setActiveLetter(py, index) {
            this.activeLetter = this.activeLetter === py ? '' : py
            if(this.isInternCity){
                if(this.activeLetter){
                    this.allAreaList[index].list = []
                    if (this.currentCityType === 1) {
                        await this.getAllCity(py, index)
                    } else {
                        await this.getAllInterCity(py, index)
                    }
                }
            } else {
                if (!this.allAreaList[index].list.length) {
                    await this.getAllCity(py, index)
                }
            }
            this.$nextTick(() => {
                document.querySelector(`.letter-title${py}`).scrollIntoView({
                    behavior: 'smooth',
                })
            })
        },
        initAreaList() {
            let mapTable = {
                a: 0,
                b: 1,
                c: 2,
                d: 3,
                e: 4,
                f: 5,
                g: 6,
                h: 7,
                j: 8,
                k: 9,
                l: 10,
                m: 11,
                n: 12,
                o: 13,
                p: 14,
                q: 15,
                r: 16,
                s: 17,
                t: 18,
                w: 19,
                x: 20,
                y: 21,
                z: 22,
            }
            for (let key in mapTable) {
                this.allAreaList.push({
                    py: key.toUpperCase(),
                    list: [],
                })
            }
        },
        getAllCity(py, index) {
            return new Promise((res, rej) => {
                this.$http({
                    url: '/actgateway/marketcenter.java.activity.resource.service/v2/city/getCountryAreaInfo',
                    method: 'get',
                    data: {
                        level: this.cityLevel,
                        prefixChineseNamePY: py,
                    },
                })
                    .then(({ data }) => {
                        if (data.code === '0000') {
                            if (Array.isArray(this.appointCity)) {
                                if (this.appointCity.length) {
                                    data.result = data.result.filter(item => this.appointCity.findIndex(city => city.tcCityId == item.id) > -1)
                                }
                            }
                            data.result.forEach((item) => {
                                item.initialSinglePY &&
                                    this.allAreaList[index].list.push({
                                        latitude: item.latbd, //纬度	Number	-
                                        longitude: item.lonbd, //经度	Number	-
                                        provName: item.provName, //省份名称	String	-
                                        provId: item.provId, //省份Id	Number	-
                                        cityName: item.nameShort, //城市名称	String	-
                                        countryName: '中国',
                                        englishName: item.englishName, // 英文名称
                                        tcProvId: item.provId, //同程省份Id	Number	-
                                        tcCityId: item.id, //同程城市Id	Number	-
                                        threeCode: item.threeCode
                                            ? item.threeCode
                                            : item.provInfo &&
                                              item.provInfo.threeCode,
                                        elCityId:
                                            (item.eRegion &&
                                                item.eRegion.euId) ||
                                            '', //艺龙城市Id	String
                                    })
                            })
                            res()
                        } else {
                            rej()
                        }
                    })
                    .catch(() => {
                        rej()
                    })
            })
        },
        // 获取国际城市
        getAllInterCity(py = 'A', index = 0) {
            return new Promise((res, rej) => {
                this.$http({
                    url: '/actgateway/marketcenter.java.activity.resource.service/v2/resource/getIntlAirPortNotChina',
                    method: 'get',
                    headers: {
                        "AllE-Language": this.language || "zh-CN",
                    },
                    data: {
                        pinYinPrefix: py,
                    }
                })
                    .then(({ data }) => {
                        if (data.code === '0000') {
                            if (this.allAreaList[index] && this.allAreaList[index]['list']) {
                                this.allAreaList[index]['list'] = (data.result || []).map((item) => {
                                    if (item.pinYinFirstLetter) {
                                        return {
                                            countryName: item.countryName, //国家名称
                                            provName: item.cityName, //省份名称
                                            cityName: item.cityName, //城市名称
                                            threeCode: item.code, // 机场三字码
                                            cityCode: item.cityCode, // 城市三字码
                                        }
                                    }
                                })
                            }
                            res()
                        } else {
                            rej()
                        }
                    })
                    .catch(() => {
                        rej()
                    })
            })
        },
        // 处理弹框背景滚动问题
        afterOpen(bodyCls) {
            this.scrollTop = document.scrollingElement.scrollTop
            document.body.classList.add(bodyCls)
            document.body.style.top = -this.scrollTop + 'px'
        },
        // 处理弹框背景滚动问题
        beforeClose(bodyCls) {
            document.body.classList.remove(bodyCls)
            document.scrollingElement.scrollTop = this.scrollTop
        },
    },
}
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.city_box {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
    .city-pop {
        height: 90%;
        background-color: #fff;
        position: fixed;
        overflow-y: auto;
        bottom: 0;
        left: 0;
        width: 100%;
        border-radius: 8px 8px 0 0;
        padding: 16px 0 0;
        animation: heightChange linear 0.3s;
        .header-title {
            position: relative;
            // height: 30px;
            font-weight: bold;
            // line-height: 30px;
            text-align: center;
            font-size: 16px;
            padding: 0 14px 14px;
            background-color: #fff;
            .back {
                position: absolute;
                left: 14px;
                top: 0;
                // transform: translateY(-50%);
                width: 18px;
                height: 24px;
            }
        }
        .city_box_content{
            height: calc(100% - 35px);
            overflow-y: auto;
        }
        .fast-op-box {
            padding: 0 14px;
        /**
            .header-title {
                position: relative;
                height: 30px;
                font-weight: bold;
                line-height: 30px;
                text-align: center;
                font-size: 16px;
                .back {
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 18px;
                    height: 30px;
                }
            }
        */
            .city_type_tab{
                display: flex;
                justify-content: space-around;
                margin: 10px 0;
                border-bottom: 1px solid #dfdfdf;
                .tab-item {
                    font-size: 15px;
                    font-weight: bold;
                    color: #333;
                    padding: 8px 0;
                    cursor: pointer;
                    &.active {
                        color: #35c250;
                        border-bottom: 2px solid #35c250;
                    }
                }
            }
            .now-tip {
                height: 26px;
                line-height: 30px;
            }
            .title {
                font-size: 13px;
                color: #0d132a;
                font-weight: bold;
            }
            .locate {
                height: 55px;
                line-height: 55px;
                img {
                    width: 14px;
                    height: 14px;
                    vertical-align: middle;
                    margin-right: 8px;
                }
                span {
                    font-size: 13.5px;
                    color: #67b991;
                }
                .locate_sp {
                    font-size: 12px;
                    color: #999;
                }
            }
            .hot-title {
                height: 50px;
                line-height: 50px;
            }
            .city-item {
                box-sizing: border-box;
                overflow: hidden;
                display: inline-block;
                width: 4.6875rem;
                height: 2.25rem;
                line-height: 2.25rem;
                text-align: center;
                padding: 0 3px;
                background-color: #f5f6fa;
                margin-right: 8px;
                margin-bottom: 8px;
                font-size: 0.8125rem;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .letter-box {
            .letter-title {
                height: 2rem;
                line-height: 2rem;
                padding-left: 14px;
                font-size: 14px;
                background-color: #f4f4f4;
                border-bottom: 1px solid #dedede;
            }
            .letter-city {
                height: 2.8125rem;
                line-height: 2.8125rem;
                font-size: 13px;
                padding-left: 14px;
                border-bottom: 1px solid #f5f5f5;
            }
        }
        .right-box {
            position: fixed;
            z-index: 1;
            top: 166px;
            bottom: 30px;
            right: 0;
            width: 1.875rem;

            .right-item {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 4.54%;
                text-align: center;
                font-size: 10px;
                color: #35c250;
            }
        }
    }
}
@keyframes heightChange {
    0% {
        transform: translateY(100%);
    }
    100% {
        transform: translateY(0%);
    }
}
</style>
<style scoped lang="scss">
.re {
    position: relative;
}
.ab {
    position: absolute;
}
.city_box .scrollable {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    height: 75%;
    min-height: 500px;
}
.city_box .city_close {
    width: 10%;
    margin-left: 45%;
    margin-top: 5%;
    img {
        width: 100%;
    }
}
.city_box .loading_box {
    width: 10%;
    margin: 0 auto;
    padding: 120px 0;
}
.city_box .mask {
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 999;
    position: fixed;
    top: 0;
    bottom: 0;
}
.city_box .search_box1 {
    margin-top: 12px;
    padding: 0 15px;
}
.city_box .locate_box {
    margin-top: 12px;
    padding: 12px 0;
    font-size: 14px;
    color: #9a9a9a;
    padding: 0 15px;
}
.city_box .search_input {
    font-size: 13px;
    padding: 10px 5% 10px 10%;
    color: #7d7c81;
    background-color: #efeef3;
    display: inline-block;
    text-align: left;
    width: 100%;
    border-radius: 18px;
    line-height: 1.1;
}
.city_box .search_icon {
    width: 5%;
    left: 7%;
    top: 23%;
}
.city_box .locate_p {
    font-size: 16px;
    color: #333333;
    margin-top: 24px;
    padding: 18px 24px 18px 8%;
    border-bottom: 1px solid #ededed;
    text-align: left;
}
.city_box .locate_sp {
    font-size: 12px;
    margin-left: 2%;
}
.city_box .locate_icon {
    /* font-size: 1rem; */
    width: 4%;
    top: 29%;
    left: 6%;
}
.city_box .search_icon em {
    color: #efeef3;
    font-size: 20px;
}
input {
    border: none;
    outline: medium;
    background: no-repeat 0 0 scroll none;
}
input:focus::-webkit-input-placeholder {
    color: #333333;
    opacity: 0;
}
em {
    font-style: inherit;
}
.city_box .hot_box {
    /* font-size: 1rem; */
    color: #999999;
    padding: 0 15px;
}
.city_box .result_box {
    padding: 9px 18px 0;
}
.city_box .result_box p {
    font-size: 12px;
    padding: 12px 0;
}
.city_box .hot_box_p {
    font-size: 13px;
    color: #999999;
    padding: 18px 0;
    text-align: left;
}
.city_box .city_title {
    color: #a7a7a7;
    font-size: 14px;
    margin-bottom: 12px;
    margin-left: 5px;
}
.city_box .city_icon {
    color: #585858;
    font-size: 14px;
    padding: 10px 12px;
    border: 1px solid #dfdfdf;
    display: inline-block;
    margin-bottom: 12px;
}
.city_box .city_icon em {
    color: #999999;
    font-size: 10px;
    margin-left: 4px;
}
.city_box .hote_city_p {
    display: -webkit-box;
    width: 100%;
    margin-bottom: 12px;
}
.city_box .h_c_sp1,
.city_box .h_c_sp2,
.city_box .h_c_sp3 {
    display: block;
    width: 30%;
    text-align: center;
    padding: 10px 0;
    border: 1px solid #dedfe0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-wrap: break-word;
    word-break: break-all;
    color: #333333;
    font-size: 14px;
}
.city_box .h_c_sp2,
.city_box .h_c_sp3 {
    margin-left: 4%;
}
.history-box {
    color: #999999;
    padding: 0 15px;
}
.city_close {
    width: 10%;
    /* position: fixed; */
    /* bottom: 5%; */
    /* left: 45%; */
    margin-left: 45%;
    margin-top: 5%;
}
</style>
